const setCookie = (cname, cvalue, expirationPeriod) => {
  function htmlEntitiesEncode(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  const splitDomain = window.location.hostname.split('.');
  const baseURL = splitDomain.slice(-2).join('.');
  const cookieDomain = baseURL == 'localhost' ? baseURL : `.${baseURL}`;

  expirationPeriod = expirationPeriod || 182 * 24 * 60 * 60 * 1000; // 6 months (timeout period)
  const d = new Date();
  d.setTime(d.getTime() + expirationPeriod);
  const expires = `expires=${d.toGMTString()}`;

  cvalue = cvalue.replace(/\|{2,}/g, '|').replace(/^\|/, '');
  cvalue = cvalue.replace(';', '');

  cvalue = htmlEntitiesEncode(cvalue);
  document.cookie = `${cname}=${cvalue}; ${expires};domain=${cookieDomain};path=/`;
};

export default setCookie;
